module.exports = __webpack_public_path__ + "img/card3.2e4a385e.png";